/**
 * Minimal logger that emits to console only in dev (or when explicitly enabled).
 * Replaces stray console.* calls in pages/components so that no debug noise
 * is shipped to production users.
 */
const isDev =
  typeof process !== 'undefined' &&
  process.env &&
  process.env.NODE_ENV !== 'production';

const noop = () => {};

export const logger = {
  info: isDev ? (...args) => console.info('[validatedboat]', ...args) : noop,
  warn: isDev ? (...args) => console.warn('[validatedboat]', ...args) : noop,
  error: isDev ? (...args) => console.error('[validatedboat]', ...args) : noop,
};

export default logger;
